import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NavParams, App } from 'ionic-angular';
import { RouteProvider } from '../../providers/route/route';
import { INavInfo } from '../../model/models/layout/nav-info.interface';
import { AuthProvider } from '../../providers/authorization/auth';
import { RmtPopupComponent } from '../rmt-popup/rmt-popup';
import { LoggerProvider } from '../../providers/logger/logger';
import { APP_CONFIG, Env } from '../../environment';
import { IOrder } from '../../model/models/order/order-interface';
import { IterableInAppProvider } from '../../providers/marketing/iterable-inapp';
import { ChatProvider } from '../../providers/zendesk/chat';
import { timeInterval } from 'rxjs/operator/timeInterval';
import { TranslateService } from '@ngx-translate/core';
import { SystemProvider } from '../../providers/system/system';

@Component({
  selector: 'rmt-header',
  templateUrl: 'rmt-header.html'
})
export class RmtHeaderComponent {
  @ViewChild('appbar') appbar;
  @Input() showBack: boolean = true;
  @Input() showClose: boolean = false;
  @Input() showRightClose: boolean = false;
  @Input() showRightBell: boolean = false;
  @Input() showRightChat: boolean = false;
  @Input() showRightShare: boolean = false
  @Input() showHelp: boolean = true;
  @Input() showDelete: boolean = false;
  @Input() showUser: boolean = false;
  @Input() showUserLeft: boolean = false;
  @Input() showSearchRight: boolean = false;
  @Input() border: boolean = true;
  @Input() goToActivity: boolean = false;
  @Input() goToLogin: boolean = false;
  @Input() goToStart: boolean = false;
  @Input() goToSendSummary: boolean = false;
  @Input() goToProfileDocument: boolean = false;
  @Input() closeLicensePage: boolean = false;
  @Input() iconRight: string;
  @Input() textRight: string = '';
  @Input() onBackCallback;
  @Input() onHelpCallback;
  @Input() titleId;
  @Input() userBtnId;
  @Input() onClose;
  @Input() onBellClick;
  @Input() onShareClick;
  @Input() deleteClick;
  @Input() hasProfileNotification: boolean = false;
  @Output() clickRight = new EventEmitter<any>();
  @Input() canShowReferralBtn: boolean = false;
  @Input() canSwitchToSmallReferralBtn: boolean = false;
  @Input() referralReward: string = '';
  @Input() onReferAFriendClick = new EventEmitter<any>();
  @Input() showChatIcon: boolean = false;
  @Input() chatUnreadCount: number = 0
  @Input() onChatClick = new EventEmitter<any>();
  @Input() showSegmentButton: boolean = false; 
  @Input() toggleButtonList: Array<any> = [];
  @Input() activeToggleVal: number = 0;
  @Input() newWalletUI: boolean = false;
  @Output() toggleButtonClkEvn = new EventEmitter<any>();

  onSegmentChanged = new EventEmitter<any>();

  backPage: INavInfo;
  onBack;
  order: IOrder = {};

  leftButtonType = 'back';
  rightButtonType = 'help';

  debug: boolean = false;
  debugVisible: boolean = false;
  debugVersion: string;

  showNotificationOnIDExpired: boolean = false;

  appInfo;

  static app;
  static route;
  static translate;

  constructor(private app: App,
              private routeProvider: RouteProvider,
              private navParams: NavParams,
              private iterableInAppProvider: IterableInAppProvider,
              private chatProvider: ChatProvider,
              private systemProvider: SystemProvider,
              private translate: TranslateService) {
    if (APP_CONFIG.env !== Env.PROD)
      this.debug = APP_CONFIG.showDebug;

    RmtHeaderComponent.app = this.app;
    RmtHeaderComponent.route = this.routeProvider;
    RmtHeaderComponent.translate = this.translate;

    this.backPage = this.navParams.get('backPage');
    this.onBack = this.navParams.get('onBack');
    this.order = this.navParams.get('order');
  }

  async ngAfterViewInit() {
    this.leftButtonType = '';
    // this.showNotificationOnIDExpired = this.hasProfileNotification;
    if (this.showBack)
      this.leftButtonType = 'back';
    else if (this.showClose)
      this.leftButtonType = 'close';
    else if (this.showUserLeft)
      this.leftButtonType = 'profile'

    this.appInfo = await this.systemProvider.getAppReleaseInfo()

    await this.initRightButton();

  }

  async ngOnChanges(){
    await this.initRightButton();
  }

  async initRightButton(){
    let rightButtonType = '';
    if (this.showHelp)
      rightButtonType = 'help';
    else if (this.showUser)
      rightButtonType = 'profile';
    else if (this.showRightClose)
      rightButtonType = 'close';
    else if (this.showSearchRight)
      rightButtonType = 'search';
    else if(this.showDelete)
      rightButtonType = 'delete';
    else if (this.showRightBell)
      rightButtonType = 'bell';
    else if (this.showRightChat)
      rightButtonType = 'chat';
    else if (this.showRightShare)
      rightButtonType = 'share';

    if (rightButtonType !== this.rightButtonType) {
      this.rightButtonType = rightButtonType;
    }
  }

  async setBell(){
    const InAppMessageUnreadCount = await this.iterableInAppProvider.getInAppMessageUnreadCount();
    // this.rightButtonType = InAppMessageUnreadCount ? 'unread_bell' : 'bell';
  }

  async setChatIcon() {
    this.chatProvider && this.chatProvider.getUnreadCount(); 
  }

  getChatIcon() {
    return this.showRightChat && this.chatProvider && this.chatProvider.getUnreadCount();
  }

  static back() {
    if(!this.app)
      return false;

    LoggerProvider.info(this, 'Pressed back button');

    const navCtrl = this.app.getActiveNavs()[0];
    const rootCtrl = this.app.getRootNavs()[0];
    if(navCtrl === this.route.getCurrentTab() && AuthProvider.isLoggedIn())
      return false;
    else if (navCtrl.canGoBack() || rootCtrl !== navCtrl)
      this.route.pop();
    else {
      let page = this.route.pages.PreLoginPage;
      if (AuthProvider.isLoggedIn())
        page = this.route.pages.TabsHomePage

      if (page.page === this.route.getLastActivePage()) {
        return false;
      }

      if (!AuthProvider.isLoggedIn() && this.route.getLastActivePage() !== this.route.pages.SigninPage.page)
        RmtPopupComponent.showErrorWithLogTranslation("page.errorPage.sessionExpired");

      this.route.setRoot(page);
    }
    return true;
  }
  debugShow() {
    if (!this.debug)
      return;

    this.debugVisible = !this.debugVisible;
    if (this.debugVisible)
      this.debugVersion = LoggerProvider.appVersion;
  }

  rightButtonClick() {
    this.clickRight.emit();
  }

  toggleButtonClick(event) {
    this.toggleButtonClkEvn.emit(event);
  }

  getHeaderUnreadCount() {
    return this.chatProvider.getHeaderUnreadCount();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-header/rmt-header.ts